<div class="d-flex justify-content-center align-items-center">
  <div class="spinner-border text-primary me-3" role="status"></div>
  @if (message) {
    <span class="ml-1" [style.line-height.px]="30">{{ message }}</span>
  }
</div>
